import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

export class EchoService {
  constructor() {
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: process.env.VUE_APP_PUSHER_APP_KEY,
      cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
      wsHost: `ws-${process.env.VUE_APP_PUSHER_APP_CLUSTER}.pusher.com`,
      wsPort: 80,
      wssPort: 443,
      forceTLS: 'https',
      enabledTransports: ['ws', 'wss'],
    });

    this.echo = window.Echo
  }

  listen(channelName, eventName, callback) {
    return this.echo.channel(channelName).listen(eventName, callback);
  }

  leave(channelName) {
    try {
      this.echo.leave(channelName);
    } catch (error) {
      throw new Error(error)
    }
  }

  leaveAll() {
    try {
      this.echo.leaveAllChannels();
    } catch (error) {
      throw new Error(error)
    }
  }

  disconnect() {
    try {
      this.echo.disconnect();
    } catch (error) {
      throw new Error(error)
    }
  }
}
